import styled, { css } from 'styled-components';

export const SubscriptionCardWrapper = styled.div<{ $selected: boolean }>`
  display: flex;
  min-width: 250px;
  width: 100%;
  min-height: 156px;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid
    ${({ $selected, theme }) => ($selected ? theme.colors.green4 : theme.colors.black3)};
  background: ${({ $selected, theme }) => ($selected ? theme.colors.green1 : theme.colors.white)};
  transition: all 0.3s ease;
  &:hover {
    ${({ $selected }) =>
      $selected
        ? css`
            border: 2px solid ${({ theme }) => theme.colors.green4};
          `
        : css`
            background: ${({ theme }) => theme.colors.black1};
          `}
  }
`;

export const CourseInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const CourseName = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  align-self: stretch;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const CourseProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const ProgressBarWrapper = styled.div`
  width: 70px;
`;
export const EmojiWrapper = styled.div`
  display: flex;
  width: 48px;
  height: 48px;
  padding: 12px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  aspect-ratio: 1/1;
  font-size: 38px;
  font-weight: 600;
  line-height: 46px;
`;

export const ProgressText = styled.span`
  color: ${({ theme }) => theme.colors.black7};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
